import { Component, OnInit } from '@angular/core';
import {EmissionService} from 'services/emission.service';
import {VehicleService} from 'services/calculator-items/vehicle.service';
import {IndividualTravelService} from 'services/calculator-items/individual-travel.service';
import {BusinessFleetService} from 'services/calculator-items/business-fleet.service';
import {EventsTravelService} from 'services/calculator-items/events-travel.service';

@Component({
    selector: 'tpc-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    constructor(private emissionService: EmissionService,
                private vehicleService: VehicleService,
                private travelService: IndividualTravelService,
                private fleetService: BusinessFleetService,
                private eventsTravelService: EventsTravelService
    ) {
        // if some data exists in service than clean all the data
        let isCalculatorWasUsed = Object.keys(emissionService.getEmission().categories).length;

        if (isCalculatorWasUsed) {
            emissionService.clearSavedData();
            vehicleService.cleanVehicleList();
            travelService.cleanFlightList();
            fleetService.cleanVehicleList();
            eventsTravelService.cleanList();
        }
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts